export default __webpack_public_path__ + "static/media/QuickWinsWithoutEdit.c5523459.png";